import { EntityId } from "@jackfruit/common"
import { useSelector } from "react-redux"
import { blockProductFeedsSelectors } from "~/redux/state/blockProductFeeds"
import { RootState } from "~/redux/store"

export const useProductFeedBlock = (id: EntityId) => {
  const productFeedBlock = useSelector((state: RootState) =>
    blockProductFeedsSelectors.selectById(state, id)
  )

  return {
    productFeedBlock,
  }
}
